module.exports = [
	{
		"age": "16",
		"thirtyDay": "176.02",
		"sixtyDay": "104.02",
		"ninetyDay": "77.72"
	},
	{
		"age": "17",
		"thirtyDay": "178.78",
		"sixtyDay": "106.05",
		"ninetyDay": "79.54"
	},
	{
		"age": "18",
		"thirtyDay": "181.51",
		"sixtyDay": "108.09",
		"ninetyDay": "81.36"
	},
	{
		"age": "19",
		"thirtyDay": "187.14",
		"sixtyDay": "111.84",
		"ninetyDay": "84.62"
	},
	{
		"age": "20",
		"thirtyDay": "194.74",
		"sixtyDay": "116.71",
		"ninetyDay": "88.69"
	},
	{
		"age": "21",
		"thirtyDay": "202.72",
		"sixtyDay": "122",
		"ninetyDay": "93.07"
	},
	{
		"age": "22",
		"thirtyDay": "212",
		"sixtyDay": "128.11",
		"ninetyDay": "98.03"
	},
	{
		"age": "23",
		"thirtyDay": "224.71",
		"sixtyDay": "136.22",
		"ninetyDay": "104.73"
	},
	{
		"age": "24",
		"thirtyDay": "237.4",
		"sixtyDay": "144.45",
		"ninetyDay": "111.44"
	},
	{
		"age": "25",
		"thirtyDay": "251",
		"sixtyDay": "153.19",
		"ninetyDay": "118.75"
	},
	{
		"age": "26",
		"thirtyDay": "264.88",
		"sixtyDay": "162.21",
		"ninetyDay": "126.17"
	},
	{
		"age": "27",
		"thirtyDay": "278.74",
		"sixtyDay": "171.26",
		"ninetyDay": "133.79"
	},
	{
		"age": "28",
		"thirtyDay": "293.93",
		"sixtyDay": "181.21",
		"ninetyDay": "141.92"
	},
	{
		"age": "29",
		"thirtyDay": "308.18",
		"sixtyDay": "190.55",
		"ninetyDay": "149.73"
	},
	{
		"age": "30",
		"thirtyDay": "322.71",
		"sixtyDay": "200.11",
		"ninetyDay": "157.74"
	},
	{
		"age": "31",
		"thirtyDay": "346.13",
		"sixtyDay": "215.14",
		"ninetyDay": "170.14"
	},
	{
		"age": "32",
		"thirtyDay": "369.15",
		"sixtyDay": "229.97",
		"ninetyDay": "182.22"
	},
	{
		"age": "33",
		"thirtyDay": "393.76",
		"sixtyDay": "245.71",
		"ninetyDay": "195.13"
	},
	{
		"age": "34",
		"thirtyDay": "419.02",
		"sixtyDay": "261.85",
		"ninetyDay": "208.23"
	},
	{
		"age": "35",
		"thirtyDay": "444.13",
		"sixtyDay": "277.9",
		"ninetyDay": "221.24"
	},
	{
		"age": "36",
		"thirtyDay": "466.63",
		"sixtyDay": "292.11",
		"ninetyDay": "232.9"
	},
	{
		"age": "37",
		"thirtyDay": "488.89",
		"sixtyDay": "306.23",
		"ninetyDay": "244.18"
	},
	{
		"age": "38",
		"thirtyDay": "510.34",
		"sixtyDay": "319.74",
		"ninetyDay": "255.04"
	},
	{
		"age": "39",
		"thirtyDay": "531.03",
		"sixtyDay": "332.65",
		"ninetyDay": "265.29"
	},
	{
		"age": "40",
		"thirtyDay": "549.73",
		"sixtyDay": "344.12",
		"ninetyDay": "274.35"
	},
	{
		"age": "41",
		"thirtyDay": "567.79",
		"sixtyDay": "355.2",
		"ninetyDay": "282.87"
	},
	{
		"age": "42",
		"thirtyDay": "584.67",
		"sixtyDay": "365.35",
		"ninetyDay": "290.6"
	},
	{
		"age": "43",
		"thirtyDay": "599.59",
		"sixtyDay": "374.08",
		"ninetyDay": "297.19"
	},
	{
		"age": "44",
		"thirtyDay": "611.89",
		"sixtyDay": "381.29",
		"ninetyDay": "302.37"
	},
	{
		"age": "45",
		"thirtyDay": "622.49",
		"sixtyDay": "387.17",
		"ninetyDay": "306.44"
	},
	{
		"age": "46",
		"thirtyDay": "634.13",
		"sixtyDay": "393.68",
		"ninetyDay": "310.9"
	},
	{
		"age": "47",
		"thirtyDay": "643.94",
		"sixtyDay": "398.97",
		"ninetyDay": "314.46"
	},
	{
		"age": "48",
		"thirtyDay": "652.06",
		"sixtyDay": "403.13",
		"ninetyDay": "317.02"
	},
	{
		"age": "49",
		"thirtyDay": "657.3",
		"sixtyDay": "405.46",
		"ninetyDay": "318.12"
	},
	{
		"age": "50",
		"thirtyDay": "660.96",
		"sixtyDay": "406.99",
		"ninetyDay": "318.63"
	},
	{
		"age": "51",
		"thirtyDay": "666.33",
		"sixtyDay": "409.52",
		"ninetyDay": "319.85"
	},
	{
		"age": "52",
		"thirtyDay": "668.55",
		"sixtyDay": "410.15",
		"ninetyDay": "319.63"
	},
	{
		"age": "53",
		"thirtyDay": "669.72",
		"sixtyDay": "410.24",
		"ninetyDay": "319.13"
	},
	{
		"age": "54",
		"thirtyDay": "668.55",
		"sixtyDay": "408.91",
		"ninetyDay": "317.63"
	},
	{
		"age": "55",
		"thirtyDay": "665.28",
		"sixtyDay": "406.58",
		"ninetyDay": "315.27"
	},
	{
		"age": "56",
		"thirtyDay": "658.22",
		"sixtyDay": "402.01",
		"ninetyDay": "311.43"
	},
	{
		"age": "57",
		"thirtyDay": "645.64",
		"sixtyDay": "394.19",
		"ninetyDay": "304.92"
	},
	{
		"age": "58",
		"thirtyDay": "626.67",
		"sixtyDay": "382.52",
		"ninetyDay": "295.57"
	},
	{
		"age": "59",
		"thirtyDay": "599.72",
		"sixtyDay": "366.48",
		"ninetyDay": "285.83"
	},
	{
		"age": "60",
		"thirtyDay": "587.3",
		"sixtyDay": "358.96",
		"ninetyDay": "276.88"
	},
	{
		"age": "61",
		"thirtyDay": "535.47",
		"sixtyDay": "326.55",
		"ninetyDay": "250.57"
	},
	{
		"age": "62",
		"thirtyDay": "495.57",
		"sixtyDay": "300.55",
		"ninetyDay": "228.14"
	},
	{
		"age": "63",
		"thirtyDay": "456.44",
		"sixtyDay": "271.49",
		"ninetyDay": "199.29"
	},
	{
		"age": "64",
		"thirtyDay": "322.84",
		"sixtyDay": "173.49",
		"ninetyDay": "104.84"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/Git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedSixtyFiveYear.json
// module id = 455
// module chunks = 0